import api from './api';
import { API_ROUTES } from '@/lib/constants';
import type { Pipeline, DealStage, PaginatedResponse, ApiResponse } from '@/types/table';

export const pipelineService = {
  getAll: async (): Promise<PaginatedResponse<Pipeline>> => {
    const response = await api.get(API_ROUTES.PIPELINES);
    return response.data;
  },

  getById: async (id: string): Promise<ApiResponse<Pipeline>> => {
    const response = await api.get(`${API_ROUTES.PIPELINES}/${id}`);
    return response.data;
  },

  create: async (data: Partial<Pipeline>): Promise<ApiResponse<Pipeline>> => {
    const response = await api.post(API_ROUTES.PIPELINES, data);
    return response.data;
  },

  update: async (id: string, data: Partial<Pipeline>): Promise<ApiResponse<Pipeline>> => {
    const response = await api.patch(`${API_ROUTES.PIPELINES}/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`${API_ROUTES.PIPELINES}/${id}`);
  },

  addStage: async (pipelineId: string, data: Partial<DealStage>): Promise<ApiResponse<DealStage>> => {
    const response = await api.post(`${API_ROUTES.PIPELINES}/${pipelineId}/stages`, data);
    return response.data;
  },

  updateStage: async (pipelineId: string, stageId: string, data: Partial<DealStage>): Promise<ApiResponse<DealStage>> => {
    const response = await api.patch(`${API_ROUTES.PIPELINES}/${pipelineId}/stages/${stageId}`, data);
    return response.data;
  },

  deleteStage: async (pipelineId: string, stageId: string): Promise<void> => {
    await api.delete(`${API_ROUTES.PIPELINES}/${pipelineId}/stages/${stageId}`);
  },

  reorderStages: async (pipelineId: string, stageIds: string[]): Promise<void> => {
    await api.patch(`${API_ROUTES.PIPELINES}/${pipelineId}/stages/reorder`, { stageIds });
  },
};
